var map = {
	"./401.png": "b959",
	"./404.png": "16f4",
	"./500.png": "849a",
	"./aniversariantes.png": "ebe6",
	"./bg-banner-login.svg": "8f2a",
	"./clientes_unicos.png": "4494",
	"./communicate-by-channel.svg": "9e74",
	"./disconnected.png": "1c1e",
	"./empty_card.png": "d1b8",
	"./empty_decomposition.png": "c5df",
	"./empty_state.png": "1082",
	"./expired.png": "c6a4",
	"./icons/apple-touch-icon-114x114.png": "02fc",
	"./icons/apple-touch-icon-120x120.png": "05d3",
	"./icons/apple-touch-icon-144x144.png": "756c",
	"./icons/apple-touch-icon-152x152.png": "d1a1",
	"./icons/apple-touch-icon-57x57.png": "f229",
	"./icons/apple-touch-icon-60x60.png": "ce2d",
	"./icons/apple-touch-icon-72x72.png": "dfc0",
	"./icons/apple-touch-icon-76x76.png": "8c36",
	"./icons/facebook-icon.png": "9795",
	"./icons/favicon-128.png": "356b",
	"./icons/favicon-16x16.png": "0d9e",
	"./icons/favicon-196x196.png": "a3f6",
	"./icons/favicon-32x32.png": "d254",
	"./icons/favicon-96x96.png": "f94d",
	"./icons/insta-icon.png": "ac56",
	"./icons/linkedin-icon.png": "ef05",
	"./icons/mar.ia-cor.svg": "9b8c",
	"./icons/mar.ia-secondary.svg": "e026",
	"./icons/mar.ia.svg": "ee73",
	"./icons/mstile-144x144.png": "2c79",
	"./icons/mstile-150x150.png": "0404",
	"./icons/mstile-310x150.png": "23c5",
	"./icons/mstile-310x310.png": "710e",
	"./icons/mstile-70x70.png": "3e8f",
	"./icons/tiktok-icon.png": "a444",
	"./icons/twitter-icon.png": "2055",
	"./icons/whats-icon.png": "9165",
	"./icons/youtube-icon.png": "886a",
	"./logo.png": "cf05",
	"./logo_dark.png": "9b15",
	"./logo_non_dark.png": "13e7",
	"./logotipo-mercafacil-dark.svg": "15c4",
	"./maintenance.png": "b3d2",
	"./media_de_compras_por_cliente.png": "aeb8",
	"./media_de_itens_na_cesta.png": "8e5f",
	"./mercafacil-dark.svg": "be74",
	"./modelo.png": "0513",
	"./modelos-segmento/aniversariantesdodia.png": "303e",
	"./modelos-segmento/cadastrosnosultimos7dias.png": "1723",
	"./modelos-segmento/comprarammespassado.png": "73b8",
	"./modelos-segmento/homensde18a60anos.png": "18e1",
	"./modelos-segmento/inativosrecentes.png": "d327",
	"./modelos-segmento/modeloembranco.png": "1809",
	"./modelos-segmento/nuncacompraram.png": "740a",
	"./modelos-segmento/pfcomticketmediode50a100reais.png": "0ab9",
	"./modelos-segmento/riscodeperder.png": "157c",
	"./new-analyse.svg": "9ff0",
	"./novo.png": "362a",
	"./offline-number-tip-v2.png": "387a",
	"./offline-number-tip.png": "6b93",
	"./price-range/catedral.png": "f210",
	"./price-range/copacabana.png": "20a3",
	"./price-range/cristo.png": "c484",
	"./price-range/elevador-lacerda.png": "aede",
	"./price-range/faixa.png": "f0c7",
	"./price-range/jardim-botanico.png": "a43e",
	"./price-range/museu.png": "acc0",
	"./price-range/pao-de-acucar.png": "8ffe",
	"./price-range/ponto1.png": "0622",
	"./price-range/ponto2.png": "0788",
	"./reportExportTrackingLoader.png": "c490",
	"./sem_acesso.png": "7d12",
	"./smart-dark.svg": "a988",
	"./store_pin.png": "7c2e",
	"./store_pin_shadow.png": "6c18",
	"./styles/global.scss": "c860",
	"./tribanco-dark.svg": "230d",
	"./unitsGroupsEmptyState.svg": "d197",
	"./update.png": "090e",
	"./valor_medio_dos_produtos.png": "dc06",
	"./warning_cart.png": "838c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";